export function isEmpty(obj: object): boolean {
  return Object.keys(obj).length === 0
}
